import { useTheme } from '@emotion/react';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import { FC } from 'react';
import { Link as NavLink } from 'react-router-dom';
import { Card, CardHeader, Link, Links } from './LinkListCard.styles';
import { LinkListCardProps } from './LinkListCard.types';

const LinkListCard: FC<LinkListCardProps> = ({ links, title }) => {
  const theme = useTheme();
  const renderLinks = links.map((link, index, arr) => {
    const hideMenu = () => (document.activeElement as HTMLElement).blur();
    return (
      <Link showDivider={index !== arr.length - 1} key={link.to}>
        <NavLink data-testid={link.testId} to={link.to} onClick={hideMenu}>
          {link.label}
          <ChevronRightOutlined htmlColor={theme.colors.blue} />
        </NavLink>
      </Link>
    );
  });

  return (
    <Card>
      <CardHeader>{title}</CardHeader>
      <Links>{renderLinks}</Links>
    </Card>
  );
};

export default LinkListCard;
